import {
    SET_USER_PURPOSES,
    REMOVE_USER_PURPOSE,
    ADD_USER_PURPOSE,
    SET_COOKIE_NAME,
    SET_EXPIRE_TIME_ALL_POSITIVE,
    SET_EXPIRE_TIME_ONE_NEGATIVE,
    SET_COOKIE_EXPIRE_TIME,
    SET_USER_CONSENT,
    SET_USER_CUSTOM_PURPOSES,
    SET_USER_FEATURES,
    SET_USER_VENDORS,
} from "../action_types";

import store from "../store";

export const setUserConsent = (consent) => ({
    type: SET_USER_CONSENT,
    consent,
});

export const setUserPurposes = (purposes) => ({
    type: SET_USER_PURPOSES,
    consent: {
        purposes,
    },
});

export const removeUserPurpose = (id) => ({
    type: REMOVE_USER_PURPOSE,
    id,
});

export const addUserPurpose = (id) => ({
    type: ADD_USER_PURPOSE,
    id,
});

export const setUserCustomPurposes = (custom) => ({
    type: SET_USER_CUSTOM_PURPOSES,
    consent: {
        custom,
    },
});

export const setUserFeatures = (features) => ({
    type:SET_USER_FEATURES,
    consent: {
        features,
    },
});

export const setUserVendors = (vendors) => ({
    type: SET_USER_VENDORS,
    consent: {
        vendors,
    },
});

export const setCookieName = (cookieName) => ({
    type: SET_COOKIE_NAME,
    cookieName,
});

export const setCookieExpireTime = (expireTime) => ({
    type: SET_COOKIE_EXPIRE_TIME,
    expireTime,
});

export const setExpireTimeAllPositive = (expireTime) => ({
    type: SET_EXPIRE_TIME_ALL_POSITIVE,
    expireTime,
});

export const setExpireTimeOneNegative = (expireTime) => ({
    type: SET_EXPIRE_TIME_ONE_NEGATIVE,
    expireTime,
});

export const boundSetUserConsent = (consent) => store.dispatch(setUserConsent(consent));
export const boundSetUserPurposes = (purposes) => store.dispatch(setUserPurposes(purposes));
export const boundAddUserPurpose = (id) => store.dispatch(addUserPurpose(id));
export const boundRemoveUserPurpose = (id) => store.dispatch(removeUserPurpose(id));
export const boundSetUserFeatures = (features) => store.dispatch(setUserFeatures(features));
export const boundSetUserVendors = (vendors) => store.dispatch(setUserVendors(vendors));
export const boundSetUserCustomPurposes = (customs) => store.dispatch(setUserCustomPurposes(customs));

export const boundSetCookieName = (name) => store.dispatch(setCookieName(name));
export const boundSeCookieExpireTime = (time) => store.dispatch(setCookieExpireTime(time));
export const boundSetExpireTimeAllPositive = (time) => store.dispatch(setExpireTimeAllPositive(time));
export const boundSetExpireTimeOneNegative = (time) => store.dispatch(setExpireTimeOneNegative(time));